<template>
  <div>
    <div class="title">
      Quick Links:
    </div>
    <div class="d-flex flex-column">
      <router-link class="link ic-style-guidelines" :to="{name: 'forAuthorsStyleGuidelines'}">Style Guidelines<i class="icon icon-color-arrow-right-dark"></i></router-link>
      <!-- ToDO: submit a paper link -->
      <router-link class="link ic-submit" :to="{name: 'forAuthorsStyleGuidelines'}">Submit a Paper<i class="icon icon-color-arrow-right-dark"></i></router-link>
      <!-- ToDO: open link scrolled to section -->
      <router-link class="link ic-peer-review" :to="{name: 'forAuthorsPolicies', hash: '#peer-review'}">Peer Review<i class="icon icon-color-arrow-right-dark"></i></router-link>
      <router-link class="link ic-plagerism" :to="{name: 'forAuthorsPolicies', hash: '#plagerism'}">Plagerism<i class="icon icon-color-arrow-right-dark"></i></router-link>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'sidebar-quick-links',
    data () {
      return {
      }
    }
  }
</script>
<style scoped lang="scss">
  .title {
    font-family: 'Merriweather';
    font-style: italic;
    color: $primary-color;
    font-size: 14px;
    margin-bottom: 15px;
  }
  .link {
    height: 48px;
    width: 100%;
    line-height: 48px;
    text-align: center;
    font-family: 'Merriweather';
    font-style: italic;
    font-size: 16px;
    color: $primary-color;
    background-color: $link-button-bg;
    border-left: 5px solid $link-button-border-left;
    border-bottom: 1px solid $link-button-border-bottom;
    margin-bottom: 12px;
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: 5%;
    background-image: none;
    white-space: nowrap;
    padding: 0 calc(7% + 36px);
    overflow: hidden;
    &:before {
       position: absolute;
       content: '';
       left: 7%;
       display: block;
       width: 48px;
       height: 48px;
       background-repeat: no-repeat;
       background-position: center;
       background-color: $link-button-bg;
    }
    .icon {
      margin-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarQuickLinksComponent.vue?3028874c